import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@/styles/globals.css'
import { ThemeProvider } from '@/components/theme-provider'
import App from './App'

const root = document.getElementById('root')

if (!root) {
  throw new Error('No root element found')
}

createRoot(root).render(
  <StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </StrictMode>
)

const initialLoader = document.getElementById('app-loading')
if (initialLoader) {
  initialLoader.classList.add('app-loading--hidden')
  window.setTimeout(() => initialLoader.remove(), 400)
}
